import Experience from '../Experience'
import { gsap } from 'gsap'
import ScrollEvent from './ScrollEvent'

export default class Works {

    domElements = {
        headers: document.querySelectorAll('.works-header'),
        blockHeaders: document.querySelectorAll('#books-section .works-block-header, #books-section .works-subtitle, #press-section .works-subtitle'),
        singles: document.querySelectorAll('#books-section .works-reveal, #press-section .works-reveal'),
        groups: document.querySelectorAll('#books-section .works-reveal-group, #press-section .works-reveal-group'),
        marquee: document.getElementById('works-marquee'),
    }

    marqueeSpeed = 45

    isCurrentSwipeElement = false

    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes

        this.setupMarquee()
        this.addScrollEvents(true)
    }

    getRevealTargets() {
        const targets = []

        this.domElements.headers.forEach((header) => {
            header.querySelectorAll(':scope > h2, :scope > .works-intro').forEach((element) => targets.push({ element: element, children: [element] }))
        })

        const singles = [...this.domElements.blockHeaders, ...this.domElements.singles]
        singles.forEach((element) => targets.push({ element: element, children: [element] }))
        this.domElements.groups.forEach((group) => targets.push({ element: group, children: Array.from(group.children) }))
        targets.push({ element: this.domElements.marquee, children: [this.domElements.marquee] })

        return targets
    }

    addScrollEvents(withSetup = false) {
        this.scrollEvents = this.getRevealTargets().map(({ element, children }) => new ScrollEvent({
            element: element,
            direction: 'down',
            offset: 60,
            f: () => gsap.to(children, { y: 0, opacity: 1, duration: .6, stagger: .08, ease: 'power2.out' }),
            setup: withSetup ? () => gsap.set(children, { y: 80, opacity: 0 }) : undefined,
            reset: () => gsap.set(children, { y: 0, opacity: 1 }),
        }))
    }

    resetPositions() {
        this.scrollEvents.forEach((event) => event.reset())
    }

    setupMarquee() {
        const track = this.domElements.marquee.querySelector('.works-marquee-track')
        this.marqueeGroup = track.querySelector('.works-marquee-group')
        this.marqueeItems = Array.from(this.marqueeGroup.children)

        this.marqueeClone = this.marqueeGroup.cloneNode(true)
        this.marqueeClone.classList.add('works-marquee-clone')
        this.marqueeClone.setAttribute('aria-hidden', 'true')
        this.marqueeClone.removeAttribute('aria-label')
        track.appendChild(this.marqueeClone)

        this.fillMarquee()

        this.marqueeItems.forEach((item) => {
            const image = item.querySelector('img')
            if (image && !image.complete)
                image.addEventListener('load', () => this.fillMarquee(), { once: true })
        })
    }

    fillMarquee() {
        const containerWidth = this.domElements.marquee.clientWidth

        //Repeat logos until one group is wider than the visible area, so the loop never shows a gap
        let guard = 0
        while (this.marqueeGroup.scrollWidth < containerWidth && guard < 6) {
            this.marqueeItems.forEach((item) => {
                const copy = item.cloneNode(true)
                copy.setAttribute('aria-hidden', 'true')
                this.marqueeGroup.appendChild(copy)
                this.marqueeClone.appendChild(copy.cloneNode(true))
            })
            guard++
        }

        const groupWidth = this.marqueeGroup.scrollWidth
        if (groupWidth > 0)
            this.domElements.marquee.style.setProperty('--works-marquee-duration', (groupWidth / this.marqueeSpeed) + 's')
    }

    resize() {
        setTimeout(() => {
            this.addScrollEvents()
            this.fillMarquee()
        })
    }
}
